import { darkModalOutline } from "Styles/darkModal";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 60px;
  padding: 40px 0;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  ${media.greaterThan("medium")`
    width: 1024px;
    margin: 0 auto;
    max-width: 1300px;
  `};
`;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Modal = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.black};
  padding: 40px;
  width: 100%;
  max-width: 500px;
  color: ${({ theme }) => theme.colors.neutral.white};

  display: flex;
  flex-direction: column;
  gap: 20px;

  /* Contorno: sem ele o modal se funde ao fundo preto da pagina. */
  ${darkModalOutline}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
`;

export const ModalButtons = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
